import React from 'react';

export default function RecurringAppointmentConfig({
  isRecurring,
  recurringIntervalWeeks,
  recurringEndType,
  recurringEndCount,
  recurringEndDate,
  startDate,
  hasPaymentRestriction,
  intervalWeeksError,
  endCountError,
  endDateError,
  showSeriesOptions,
  isRecurringAppointment,
  seriesEditMode,
  onToggleRecurring,
  onIntervalChange,
  onEndTypeChange,
  onEndCountChange,
  onEndDateChange,
  onSeriesEditModeChange,
}) {
  return (
    <>
      <div className="space-y-4 pt-4 border-t border-gray-100">
        <div className="flex items-center justify-between">
          <label className="flex items-center space-x-3 rtl:space-x-reverse">
            <input
              type="checkbox"
              checked={isRecurring}
              onChange={(e) => onToggleRecurring(e.target.checked)}
              disabled={hasPaymentRestriction}
              className="w-4 h-4 ml-2 text-pink-600 border-gray-300 rounded focus:ring-pink-500 disabled:opacity-50 disabled:cursor-not-allowed"
            />
            <span className={`text-sm font-medium ${hasPaymentRestriction ? 'text-gray-400' : 'text-gray-700'}`}>
              הפעל סדרת פגישות (תור חוזר)
            </span>
          </label>
        </div>

        {isRecurring && (
          <div className="bg-pink-50 rounded-lg p-4 space-y-4 border border-pink-100">
            <div className="flex items-center">
              <span className="text-sm ml-2 text-gray-600">חזרה כל </span>
              <div className="flex items-center space-x-2 rtl:space-x-reverse">
                <input
                  type="number"
                  min="1"
                  max="52"
                  value={recurringIntervalWeeks}
                  disabled={hasPaymentRestriction}
                  onChange={(e) => onIntervalChange(e.target.value)}
                  className="w-20 px-3 py-2 ml-2 border border-gray-300 rounded-md focus:ring-pink-500 focus:border-pink-500 text-center disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                <span className="text-sm text-gray-600">שבועות</span>
              </div>
              {intervalWeeksError && (
                <p className="mt-1 text-sm text-red-600">{intervalWeeksError}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                סיום החזרה
              </label>
              <div className="space-y-3">
                <label className="flex items-center space-x-3 rtl:space-x-reverse">
                  <input
                    type="radio"
                    name="recurring_end_type"
                    value="count"
                    checked={recurringEndType === 'count'}
                    onChange={(e) => onEndTypeChange(e.target.value)}
                    disabled={hasPaymentRestriction}
                    className="w-4 h-4 ml-1 text-pink-600 border-gray-300 focus:ring-pink-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  />
                  <span className="text-sm text-gray-700">אחרי</span>
                  <input
                    type="number"
                    min="1"
                    max="100"
                    value={recurringEndCount}
                    onChange={(e) => onEndCountChange(e.target.value)}
                    disabled={recurringEndType !== 'count' || hasPaymentRestriction}
                    className="w-20 px-2 py-1 border border-gray-300 rounded text-center disabled:bg-gray-100"
                  />
                  <span className="text-sm text-gray-700">פעמים</span>
                </label>
                {endCountError && recurringEndType === 'count' && (
                  <p className="mt-1 text-sm text-red-600">{endCountError}</p>
                )}

                <label className="flex items-center space-x-3 rtl:space-x-reverse flex-wrap">
                  <input
                    type="radio"
                    name="recurring_end_type"
                    value="date"
                    checked={recurringEndType === 'date'}
                    onChange={(e) => onEndTypeChange(e.target.value)}
                    disabled={hasPaymentRestriction}
                    className="w-4 h-4 ml-1 text-pink-600 border-gray-300 focus:ring-pink-500 flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed"
                  />
                  <span className="text-sm text-gray-700 flex-shrink-0">עד תאריך</span>
                  <div className="relative min-w-0 flex-1">
                    <input
                      type="date"
                      value={recurringEndDate}
                      onChange={(e) => onEndDateChange(e.target.value)}
                      disabled={recurringEndType !== 'date' || hasPaymentRestriction}
                      className="w-full min-w-0 px-3 py-1 border border-gray-300 rounded disabled:bg-gray-100"
                      style={{ maxWidth: '100%' }}
                      min={startDate}
                    />
                  </div>
                </label>
                {endDateError && recurringEndType === 'date' && (
                  <p className="mt-1 text-sm text-red-600">{endDateError}</p>
                )}
              </div>
            </div>

            {isRecurring && recurringIntervalWeeks && (
              <div className="text-xs text-gray-600 bg-white p-2 rounded border">
                <strong>תצוגה מקדימה:</strong> תור חוזר כל {recurringIntervalWeeks} {recurringIntervalWeeks === '1' ? 'שבוע' : 'שבועות'}
                {recurringEndType === 'count' && recurringEndCount && (
                  <span> למשך {recurringEndCount} פעמים</span>
                )}
                {recurringEndType === 'date' && recurringEndDate && (
                  <span> עד {new Date(recurringEndDate).toLocaleDateString('he-IL')}</span>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {showSeriesOptions && isRecurringAppointment && (
        <div className="space-y-3 pt-4 border-t border-gray-100">
          <label className="block text-sm font-medium text-gray-700">
            איזה תורים לערוך?
          </label>
          <div className="space-y-2">
            <label className="flex items-center space-x-3 rtl:space-x-reverse">
              <input
                type="radio"
                name="seriesEditMode"
                value="single"
                checked={seriesEditMode === 'single'}
                onChange={(e) => onSeriesEditModeChange(e.target.value)}
                disabled={hasPaymentRestriction}
                className="w-4 h-4 ml-1 text-pink-600 border-gray-300 focus:ring-pink-500 disabled:opacity-50 disabled:cursor-not-allowed"
              />
              <span className={`text-sm ${hasPaymentRestriction ? 'text-gray-400' : 'text-gray-700'}`}>רק התור הזה</span>
            </label>
            <label className="flex items-center space-x-3 rtl:space-x-reverse">
              <input
                type="radio"
                name="seriesEditMode"
                value="future"
                checked={seriesEditMode === 'future'}
                onChange={(e) => onSeriesEditModeChange(e.target.value)}
                disabled={hasPaymentRestriction}
                className="w-4 h-4 ml-1 text-pink-600 border-gray-300 focus:ring-pink-500 disabled:opacity-50 disabled:cursor-not-allowed"
              />
              <span className={`text-sm ${hasPaymentRestriction ? 'text-gray-400' : 'text-gray-700'}`}>התור הזה ועתידיים</span>
            </label>
            <label className="flex items-center space-x-3 rtl:space-x-reverse">
              <input
                type="radio"
                name="seriesEditMode"
                value="all"
                checked={seriesEditMode === 'all'}
                onChange={(e) => onSeriesEditModeChange(e.target.value)}
                disabled={hasPaymentRestriction}
                className="w-4 h-4 ml-1text-pink-600 border-gray-300 focus:ring-pink-500 disabled:opacity-50 disabled:cursor-not-allowed"
              />
              <span className={`text-sm ${hasPaymentRestriction ? 'text-gray-400' : 'text-gray-700'}`}>כל התורים בסדרה</span>
            </label>
          </div>

          {(seriesEditMode === 'future' || seriesEditMode === 'all') && (
            <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
                <div className="flex-1">
                  <p className="text-sm font-medium text-blue-800">שים לב:</p>
                  <p className="text-sm text-blue-700 mt-1">
                    תורים ששולמו (עם חשבונית או תשלום שהושלם) לא ישונו, גם אם הם חלק מהסדרה החוזרת. רק תורים שטרם שולמו יעודכנו.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
